import { StringValue } from '../../data-objects'
import { FieldDefinition } from './field-definition'

export class StringFieldDefinition extends FieldDefinition {
  public maxLength: number
  public isComment: boolean
  public type: StringType
  public showCharCounter: boolean
  public prefixIcon: string
  public rows: number

  constructor(field: StringFieldDefinition) {
    super(field)
    this.maxLength = field.maxLength
    this.isComment = field.isComment
    this.type = field.type
    this.showCharCounter = field.showCharCounter
    this.prefixIcon = field.prefixIcon
    this.rows = field.rows
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public getFieldValue(): any {
    const toReturn = new StringValue()
    return toReturn
  }
}

export enum StringType {
  Normal,
  Phone,
  Email,
  Url,
  Digit,
}
